/* istanbul ignore file */
if (window?.newrelic?.addRelease) {
  window.newrelic.addRelease(process.env.RELEASE_NAME, process.env.RELEASE_ID);
}
